// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2ffM-","question":"Question_question__2Iw08","description":"Question_description__1Gy-e"};